'use strict';

angular.module('pmtPlacesApp.directives').directive('pmtAddressBoxClaim', [
	function () {
		return {
			restrict: 'A',
			replace: true,
			scope: {
				pmtAddressBoxClaim: '@',
				diffObject: '='
			},
			link: function (scope, element, attrs) {
				attrs.$observe(
					'pmtAddressBoxClaim',
					function (newVal) {
						scope.address = scope.$eval(newVal);
					},
					true
				);
			},
			templateUrl: 'directive-templates/pmtAddressBoxClaim.html'
		};
	}
]);
